import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"
import { memoize } from "nodash"
import { playbackSliceName } from "./slice"

const root = (s: RootState) => s[playbackSliceName]

export const selectOpenPlaybackEntities = createSelector([root], (s) => s.openPlaybackEntities)

export const selectOpenPlaybackIds = createSelector([selectOpenPlaybackEntities], (entities) =>
    entities.map((e) => e.id)
)

export const selectIsPlaybackOpen = memoize((id: string) =>
    createSelector([selectOpenPlaybackIds], (ids) => ids.includes(id))
)

export const selectPictureInPictureId = createSelector([root], (s) => s.pictureInPictureId)

export const selectFollowingEntity = createSelector([root], (s) => s.followingEntity)

export const selectFollowingEntityId = createSelector(
    [selectFollowingEntity],
    (entity) => entity?.id
)
